var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 153,
    viewBox: "0 0 103 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8597 76.6802V23.2901C61.8597 10.679 52.2303 0 39.8961 0C27.786 0 17.9325 10.4471 17.9325 23.2901V76.6802C7.14305 84.3818 0.574219 97.2927 0.574219 111.232C0.572961 134.261 18.2142 153 39.8977 153C61.5812 153 79.2212 134.26 79.2212 111.232C79.2212 97.2937 72.6511 84.3811 61.8617 76.6802H61.8597ZM39.8961 12.7473C45.6525 12.7473 49.8376 17.8196 49.8376 23.2877V51.6661L29.9546 39.7477V23.288C29.9546 17.4729 34.4128 12.7476 39.8961 12.7476V12.7473Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5625 11.9448H79.6557C76.3359 11.9448 73.644 14.7958 73.644 18.3204C73.644 21.8435 76.336 24.6959 79.6557 24.6959H96.5625C99.8823 24.6959 102.574 21.845 102.574 18.3204C102.574 14.7972 99.8822 11.9448 96.5625 11.9448Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6557 50.1952H88.1091C91.429 50.1952 94.1208 47.3443 94.1208 43.8197C94.1208 40.2965 91.4288 37.4441 88.1091 37.4441H79.6557C76.3359 37.4441 73.644 40.2951 73.644 43.8197C73.6453 47.3442 76.336 50.1952 79.6557 50.1952Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5525 62.9475H79.6586C76.3387 62.9475 73.6469 65.7984 73.6469 69.323C73.6469 72.8461 76.3389 75.6985 79.6586 75.6985H92.5525C95.8723 75.6985 98.5642 72.8476 98.5642 69.323C98.5629 65.7985 95.8722 62.9475 92.5525 62.9475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/temperatureIcon.027760192c65f6e3cfbe9691f56ff731.svg";
export { ForwardRef as ReactComponent };